import { LocalizationKeyErrors } from './localizationKeyErrors';

export class Localization {
    private static localizationStorage = window.app.localization;

    // eslint-disable-next-line id-length
    public static _n(key: string, placeholders: { [key: string]: string } = {}): string {
        if (!this.keyExists(key)) {
            return this.getNonExistantKey(key);
        }

        let translationString = Localization.localizationStorage[key];

        Object.entries(placeholders).forEach(([key, value]) => {
            const placeholder = `%${key}%`;
            if (translationString.includes(placeholder)) {
                translationString = translationString.replace(placeholder, value);
            }
        });

        return translationString;
    }

    public static addLinkToText(sourceText:string, link:string, linkOptions?:string, separator:string = '%') {
        const regExp = new RegExp(`${separator}[\\w\\W ]*${separator}`, 'gim');
        const target = sourceText.match(regExp);

        if (!target) { return sourceText; }

        const linkText = target[0].replace(separator, '');
        const linkTag = `<a href="${link}" ${linkOptions}>${linkText}</a>`;
        const textReplaced = sourceText.replace(regExp, linkTag).replace(separator, '');

        return textReplaced;
    }

    private static getNonExistantKey(key: string): string {
        console.error(`Key '${key}' not found`);
        return `f_${key}#${LocalizationKeyErrors.KEY_NOT_FOUND}`;
    }

    private static keyExists(key: string) {
        return typeof Localization.localizationStorage[key] !== 'undefined';
    }
}
